import { render } from "./StudiesUploadProcessBar.vue?vue&type=template&id=242a8b53&scoped=true"
import script from "./StudiesUploadProcessBar.vue?vue&type=script&lang=js"
export * from "./StudiesUploadProcessBar.vue?vue&type=script&lang=js"

import "./StudiesUploadProcessBar.vue?vue&type=style&index=0&id=242a8b53&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242a8b53"]])

export default __exports__